import { NavigationTracking, PageTracking } from '@99designs/tracking';
import { Recommendation } from '../types';

type TrackingData = Pick<PageTracking, 'pageName' | 'pageStage' | 'pageSection'> & {
    pagePath: string;
    position?: number;
};

export function getRecommendationTrackingData(
    recommendation: Recommendation,
    trackingData: TrackingData
): NavigationTracking {
    const ctaValue = recommendation.name.replace(/\s+/g, '');

    return {
        category: trackingData.pageSection,
        label: `Content: Recommendations`,
        eventDetail: `${trackingData.pagePath};/design/get-started?mpvId=${recommendation.mpvID}&locale=en-US;Recommendations;${recommendation.source};${recommendation.name}`,
        navigationDetail: `${ctaValue}${trackingData.position ? `:${trackingData.position}` : ''}`,
        pageSection: trackingData.pageSection,
        pageStage: trackingData.pageStage,
        pageName: trackingData.pageName,
    };
}
